// import then needed Font Awesome functionality
import { library, dom } from '@fortawesome/fontawesome-svg-core';

// import the Facebook and Twitter icons
import {
    faFacebookF,
    faLinkedinIn,
    faTwitter,
    faInstagram,
} from '@fortawesome/free-brands-svg-icons';

import {
    faCaretDown,
    faCaretLeft,
    faCaretRight,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faSearch,
    faTimes,
    faExternalLinkAlt,
    faCopy,
    faMapMarkerAlt,
    faThLarge,
    faUsers,
} from '@fortawesome/free-solid-svg-icons';

// // add the imported icons to the library
library.add(
    faFacebookF,
    faLinkedinIn,
    faTwitter,
    faInstagram,
    faCaretDown,
    faCaretLeft,
    faCaretRight,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faSearch,
    faTimes,
    faExternalLinkAlt,
    faCopy,
    faMapMarkerAlt,
    faThLarge,
    faUsers
);

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();



// WEBPACK FOOTER //
// ./scripts/autoload/_fortawesome.js